import {defineStore} from "pinia";
import BidPackageAPI from "@/api/BidPackageAPI";
import { StorageSerializers, useStorage } from '@vueuse/core';
import {ref} from "vue";
import type {BidPackage} from "@/models/BidPackage";
import {createRequestDeduper} from '@/use/createRequestDeduper';

export const useBidPackageStore = defineStore('bidPackage', () => {

  const bidPackage = useStorage<BidPackage | undefined>('bidPackage', null, sessionStorage, {
    serializer: StorageSerializers.object,
  });
  const isLoading = ref<boolean>(false);
  const dedupeRequest = createRequestDeduper();
  let activeShowKey: string | null = null;

  const clear = () => {
    activeShowKey = null;
    bidPackage.value = null;
    isLoading.value = false;
  };

  const show = async (id: number, projectId: number, payload: any = {params: null}) => {
    const { params } = payload;
    const key = `bid-package:${projectId}:${id}:${JSON.stringify(params)}`;
    activeShowKey = key;

    return dedupeRequest(key, async () => {
      isLoading.value = true;
      const data = await new BidPackageAPI().show(id, projectId, params)
        .finally(() => {
          if (activeShowKey === key) {
            isLoading.value = false;
          }
        });

      if (activeShowKey === key) {
        bidPackage.value = data;
      }
    });
  }

  const acceptNda = async (id: number, projectId: number, ndaId: number) => {
    return await new BidPackageAPI().acceptNda(id, projectId, {nda_id: ndaId});
  };

  return {
    bidPackage,
    clear,
    isLoading,
    show,
    acceptNda,
  };
});
